<div *ngIf="isConfigLoaded">
	<div class="modal-header">
		<h2 class="modal-title">
			{{ config.textsKey + '.Title' | translate: config.titleParams }}
		</h2>

		<button
			id="icon-close-modal"
			*ngIf="config.canClose && config.cancelBtnText != 'Actions.No'"
			type="button"
			class="modal-button-close fal fa-times"
			(click)="onClose()"
		></button>
	</div>

	<div class="modal-body">
		<p [innerHTML]="config.textsKey + '.Body' | translate: config.bodyParams"></p>
	</div>

	<div class="modal-footer">
		<button id="btn-close-modal" *ngIf="config.canClose" type="button" class="btn btn-secondary" (click)="onClose()">
			<i class="far fa-times"></i>
			{{ config.cancelBtnText | translate }}
		</button>
		<button id="btn-action-modal" *ngIf="config.canAction" type="button" class="btn btn-secondary" (click)="onClose()">
			<i [class]="config.actionBtnIcon"></i>
			{{ config.actionBtnText | translate }}
		</button>
		<button id="btn-confirm-modal" *ngIf="config.canConfirm" type="button" class="btn btn-primary" (click)="onConfirm()">
			<i class="far fa-check"></i>
			{{ config.confirmBtnText | translate }}
		</button>
	</div>
</div>
